import { render, staticRenderFns } from "./ForgotToPunch.vue?vue&type=template&id=56585a1e"
import script from "./ForgotToPunch.vue?vue&type=script&lang=js"
export * from "./ForgotToPunch.vue?vue&type=script&lang=js"
import style0 from "./ForgotToPunch.vue?vue&type=style&index=0&id=56585a1e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports